import { OrigemDocumentoFiscalRecebidoEnum } from '../../../enums/repo-dfe/origem-documento-fiscal-recebido.enum';

export class PostManifestacaoRequest {
  idDFeRecebido: number;
  idEmpresaAlvo: number;
  idModeloDocumento: number;
  idTipoEvento: number;
  origemDocumentoFiscalRecebido: OrigemDocumentoFiscalRecebidoEnum;
  justificativa: string | null;
}
